import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ReactToPrint from "react-to-print";
import BanHangApi from "service/QuanLyMuaBan/BanHangApi";
import { formatNumber } from "utils/currencyFormat";

const AssetTable = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <table className="tableIn">
                <tbody>
                    <tr>
                        <td colSpan="8" style={{ textAlign: "center" }}>Không có tài sản.</td>
                    </tr>
                </tbody>
            </table>
        );
    }
    return (
        <table className="tableIn" style={{color:"black"}}>
            <thead>
                <tr>
                    <th style={{ textAlign: "center" }}>STT</th>
                    <th>Tên tài sản</th>
                    <th style={{ textAlign: "right" }}>Đơn giá</th>
                    <th style={{ textAlign: "right" }}>Phí khác</th>
                    <th>Ghi chú</th>
                    <th>Thông tin TS</th>
                    <th>Kho</th>
                    <th style={{ textAlign: "right" }}>Thành tiền</th>
                </tr>
            </thead>
            <tbody>
                {data.map((ts, i) => (
                    <tr key={ts.MaTaiSan || i}>
                        <td style={{ textAlign: "center" }}>{i + 1}</td>
                        <td>{`${ts.TenTaiSan} (Mã: ${ts.MaTaiSan})`}</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(ts.SoTienBan)}</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(ts.PhiKhacBan)}</td>
                        <td>{ts.GhiChuItem || ""}</td>
                        <td>{ts.ThongTinTaiSan || ""}</td>
                        <td>{ts.StoreName || ""}</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(ts.TongTienBan)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

const InPhieuBanHang = ({ show, onHide, orderId }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [templateParts, setTemplateParts] = useState([]);
    const [tableData, setTableData] = useState([]);
    const printRef = useRef();

    useEffect(() => {
        if (orderId > 0 && show) {
            setLoading(true);
            setError(null);
            Promise.all([
                BanHangApi.getInBanHang(orderId),
                BanHangApi.getChiTietInDonHang(orderId)
            ]).then(([resTemplate, resData]) => {
                
                let partialHtml = resTemplate.data || "Lỗi template";
                const data = resData.data;
                const parts = partialHtml.split("{$DanhSachTaiSan}");
                setTemplateParts(parts);
                setTableData(data?.DanhSachTaiSan || []);

            }).catch(err => {
                console.error(err);
                setError("Lỗi tải dữ liệu phiếu in.");
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [orderId, show]); 

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            className="modal fade text-left popup-detail"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header style={{ borderBottom: "none" }}>
                 <h4 className="modal-title color7-bold">
                     <span className="btn-icon-right color7-bold"><img src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png" alt="logo" style={{ height: 24 }} /></span>
                     In phiếu bán hàng
                 </h4>
                 <button type="button" className="close-popup-new" onClick={onHide}>
                     <i className="mdi mdi-close"></i>
                 </button>
            </Modal.Header>

            <Modal.Body id="in_BanHang_content">
                {loading && (
                    <div className="text-center py-4"><Spinner animation="border" /></div>
                )}
                {error && (
                    <div className="text-center py-4 text-danger">{error}</div>
                )}
                {!loading && !error && templateParts.length > 0 && (
                    <div ref={printRef} className="print-area">
                        {templateParts.map((part, index) => (
                            <React.Fragment key={index}>
                                <div dangerouslySetInnerHTML={{ __html: part }} />
                                {index < templateParts.length - 1 && (
                                    <AssetTable data={tableData} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                )}
                <style>{`
                    #in_BanHang_content p, #in_BanHang_content table {
                        font-size: 1.1rem; 
                    }
                     .tableIn { width: 100%; border: 1px solid #CACFE7; border-collapse: collapse; }
                     .tableIn th, .tableIn td { border: 1px solid #CACFE7; padding: 5px; }
                 `}</style>
            </Modal.Body>
            <style>{`
                 .popup-detail .back-ground-footer{
                     background-color: #FFFFFF !important;
                     border-bottom-left-radius: 0.5rem; 
                     border-bottom-right-radius: 0.5rem;
                 }
             `}</style>
            <Modal.Footer className="back-ground-footer">
                <ReactToPrint
                    trigger={() => (
                        <button disabled={loading || !!error} className="btn btn-checknew">
                            <i className="mdi mdi-printer"></i> In đơn hàng
                        </button>
                    )}
                    content={() => printRef.current}
                    documentTitle={`PhieuBanHang_${orderId}`}
                />
                <button onClick={onHide} className="btn btn-v2-close" style={{ minHeight: 40 }}>
                    <i className="mdi mdi-close"></i> Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default InPhieuBanHang;